/**
 * Shared vocabulary for the profile's autosaving sections, so a section that
 * saves on its own can report progress in the same terms as the page around it.
 */

export type AutoSaveStatus = "idle" | "saving" | "saved" | "error";

/**
 * How long editing must stop before a save runs. Long enough that a continuous
 * gesture — a drag across a grid, a name being typed — is one save rather than
 * a dozen.
 */
export const AUTO_SAVE_DELAY = 1_500;

/** How long "Saved" stays on screen before the badge goes quiet again. */
export const SAVED_STATUS_DURATION = 3_000;
